<template>
  <div>
    <el-form
      ref="rowForm"
      :model="rowData"
      :label-width="labelWidth"
      class="demo-ruleForm"
      :rules="rules"
      @submit.native.prevent
    >
      <el-form-item label="积分类型" prop="pointType" >
        <el-radio-group v-model="rowData.pointType">
          <el-radio v-for="(item,index) in pointTypeList" :label="item.value"  :key="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="分值" prop="point">
        <el-input v-model.number="rowData.point" class="width" type="number"/>
      </el-form-item>

      <el-form-item label="积分描述" prop="description" >
        <el-input
          v-model="rowData.description"
          placeholder="请选择"
          type="textarea"
          maxlength="50"
          show-word-limit
          class="width"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import screenMixin from '@/utils/screenMixin'
export default {
  props: {
    rowForm: Object
  },
  mixins: [screenMixin],
  data () {
    const numLenCheck = (rule, val, callback) => {
      console.log(val, typeof (val))
      const value = val
      if (value > 1000000 || value < 1) {
        callback(new Error('数值在1至1000000之间'))
        if (value > 1000000) {
          this.rowData.point = 1000000
        }
      }
      callback()
    }

    return {
      rowData: {
        pointType: 1,
        description: '',
        point: ''
      },
      labelWidth: '110px',
      lineData: [],
      rules: {
        pointType: [{ required: true, message: '请选择', trigger: 'blur' }],
        point: [{ required: true, message: '请输入', trigger: 'blur' }, {validator: numLenCheck, trigger: 'change'}]
      },
      changeTypeList: [
        {
          label: '新增',
          value: 1
        },
        {
          label: '扣除',
          value: 3
        }
      ],
      pointTypeList: [
        {
          label: '回收积分',
          value: 1
        },
        {
          label: '积分兑换',
          value: 2
        },
        {
          label: '活动积分',
          value: 3
        }
      ]
    }
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1680) {
        this.labelWidth = '80px'
      } else if (n <= 1920) {
        this.labelWidth = '95px'
      } else {
        this.labelWidth = '140px'
      }
    }
  },

  computed: {
    getroleName () {
      return [this.rowData.roleId]
        .reduce((total, item) => {
          const target = this.roleNameData.find(
            (roleItem) => roleItem.roleId == item
          )
          target && total.push(target.roleName)
          return total
        }, [])
        .join()
    }
  },
  mounted () {
    if (this.rowForm) {
      this.rowData = {...this.rowForm, ...this.rowData}
    }
  }
}
</script>

<style lang="scss" scoped>
.width{
  width: 85%;
}
::v-deep .el-radio{
  line-height: 1.7;
}
</style>
